import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

import { WEDDING_DATE } from 'resources/constants'
import { bouquet, bowtie, bride, groom, separator } from 'resources/images'

import SectionTitle from 'components/SectionTitle'
import {
	IntroImage,
	Wrapper,
	IntroContainer,
	IntroName,
	IntroText,
	IntroSeparator,
	IntroItem,
	IntroBouquet,
	IntroBowtie,
	IntroImageWrapper,
} from './styles'

function Intro() {
	const { i18n, t } = useTranslation()

	return (
		<Wrapper id="intro">
			<div className="container">
				<IntroContainer>
					<IntroItem>
						<IntroImageWrapper>
							<IntroImage
								width="240"
								height="240"
								src={bride}
								alt="Thais Lins"
								loading="lazy"
							/>
							<IntroBouquet src={bouquet} alt="Bouquet" />
						</IntroImageWrapper>
						<IntroName>Thais Lins</IntroName>
					</IntroItem>

					<IntroSeparator src={separator} alt="&" loading="lazy" />

					<IntroItem>
						<IntroImageWrapper>
							<IntroImage
								width="240"
								height="240"
								src={groom}
								alt="Elton Viana"
								loading="lazy"
							/>
							<IntroBowtie src={bowtie} alt="Bowtie" />
						</IntroImageWrapper>
						<IntroName>Elton Viana</IntroName>
					</IntroItem>
				</IntroContainer>

				<SectionTitle>{t('weddingIntro')}</SectionTitle>
				<IntroText>
					{WEDDING_DATE.setLocale(i18n.language).toLocaleString(
						DateTime.DATETIME_MED_WITH_WEEKDAY,
					)}{' '}
					- Espaço di Trento, Nísia Floresta/RN
				</IntroText>
			</div>
		</Wrapper>
	)
}

export default Intro
